import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductPage from "../pages/product/page";
import UnternehmenPage from "../pages/unternehmen/page";
import KontaktPage from "../pages/kontakt/page";
import LegalPage from "../pages/legal/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/tuerdruecker-stifte",
    element: <ProductPage slug="tuerdruecker-stifte" />,
  },
  {
    path: "/wechsel-schlossstifte",
    element: <ProductPage slug="wechsel-schlossstifte" />,
  },
  {
    path: "/psw-stifte",
    element: <ProductPage slug="psw-stifte" />,
  },
  {
    path: "/musterkarten-stift",
    element: <ProductPage slug="musterkarten-stift" />,
  },
  {
    path: "/vierkant-stifte",
    element: <ProductPage slug="vierkant-stifte" />,
  },
  {
    path: "/vierkant-stifte-abgesetzt",
    element: <ProductPage slug="vierkant-stifte-abgesetzt" />,
  },
  {
    path: "/unternehmen",
    element: <UnternehmenPage />,
  },
  {
    path: "/kontakt",
    element: <KontaktPage />,
  },
  {
    path: "/agb",
    element: <LegalPage slug="agb" />,
  },
  {
    path: "/datenschutz",
    element: <LegalPage slug="datenschutz" />,
  },
  {
    path: "/impressum",
    element: <LegalPage slug="impressum" />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;